import {h, Fragment} from "preact"
import { useAppState, useConfig } from "@nosto/preact"
import { useEffect, useState } from "preact/hooks"

import Loader from "./elements/Loader"
import Sidebar from "./Sidebar"
import Toolbar from "./Toolbar"
import Products from "./Products"
import LoadMore from "./LoadMore"
import NoResults from "./NoResults"
import SelectedFilters from "./SelectedFilters"
import {categoriesToExcludeSwatches} from "../helpers"

export default function Category() {
    const { response: { products }, loading } = useAppState();
    const foundProducts = products && products.total > 0;
    const [ sidebarOpen, setSidebarOpen ] = useState(false);
    const [ sortOpen, setSortOpen ] = useState(false);
    // Hiding swatches for specific category 
    const config = useConfig();
    const categoryIdValue = config.categoryId();
    useEffect(() => {
        const serpElement = document.querySelector('.ns-serp');
        
        if (categoriesToExcludeSwatches.includes(categoryIdValue) && serpElement) {
            serpElement.classList.add('ns-hide-swatches');
        }
        
    }, []);
    // --------- 

    const toggleSidebar = () => {
        setSidebarOpen(prevSidebarOpen => !prevSidebarOpen);
    };

    const toggleSort = () => {
        setSortOpen(prevSortOpen => !prevSortOpen);
    };

    useEffect(() => {
        (sidebarOpen)
            ?   document.body.classList.add("overflow-hidden")
            :   document.body.classList.remove("overflow-hidden")
    }, [ sidebarOpen ])

    return (
        <div class="ns-serp">
            {foundProducts && (
                <>
                    <Sidebar
                        sidebarOpen={sidebarOpen}
                        toggleSidebar={toggleSidebar}
                    />
                    <Toolbar
                        sidebarOpen={sidebarOpen}
                        toggleSidebar={toggleSidebar}
                        sortOpen={sortOpen}
                        toggleSort={toggleSort}
                    />
                    <SelectedFilters isInSidebar = {false} />
                </>
            )}
            <div class="ns-serp-inner">
                {(loading && !foundProducts) ? (
                    <Loader />
                ) : (foundProducts) ? (
                    <>
                        <Products />
                        <LoadMore />
                    </>
                ) : (
                    <NoResults />
                )}
            </div>
        </div>
    )
}
